import { useState } from 'react'
import { Button, Divider, Modal, Radio, Space } from 'antd'
import Input from '../input'
import SearchInput from '../search-input'
import moment from 'moment'
import useSearchParams from '../../hooks/useSearchParams'
import styles from './DistributorFilterModal.module.css'

const DistributorFilterModal = ({ visible, onCancel }) => {
	const [fromDate, setFromDate] = useState(null)
	const [toDate, setToDate] = useState(null)
	const [searchTerm, setSearchTerm] = useState('')
	const [disabled, setDisabled] = useState(false)
	const { setSearchParams, clearSearchParams } = useSearchParams()

	const isFilterEnabled = () => {
		return searchTerm || (fromDate && toDate)
	}

	const onApply = async () => {
		const searchParams = {
			searchTerm,
			disabled
		}
		if (fromDate && toDate) {
			searchParams.fromDate = fromDate
			searchParams.toDate = toDate
		}

		setSearchParams(searchParams)
		onCancel()
	}

	const resetFilter = () => {
		setSearchTerm('')
		setFromDate(null)
		setToDate(null)
		clearSearchParams()
	}

	const setDisabledValue = (isDisabled) => {
		setDisabled(isDisabled)
	}

	return (
		<Modal
			visible={visible}
			onCancel={onCancel}
			width={640}
			okText='Apply'
			footer={
				[
					<Button
						style={{
							marginRight: '265px',
							border: '2px solid #D9E0E9',
							fontWeight: 'bold'
						}}
						key='reset'
						type='primary'
						shape='round'
						size='large'
						onClick={resetFilter}
						ghost
					>
						Reset Filter
					</Button>,
					<Button
						style={{
							border: '2px solid #D9E0E9',
							fontWeight: 'bold'
						}}
						key='cancel'
						type='primary'
						shape='round'
						size='large'
						onClick={onCancel}
						ghost
					>
						Cancel
					</Button>,
					<Button
						style={{ fontWeight: 'bold' }}
						key='apply'
						type='primary'
						shape='round'
						size='large'
						disabled={!isFilterEnabled()}
						onClick={onApply}
					>
						Apply
					</Button>
				]
			}
		>
			<div className={styles.container}>
				<div className={styles.searchBox}>
					<SearchInput
						placeholder='Search Destributer Name'
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
					/>
				</div>
				<div className={styles.section}>
					<Radio.Group
						style={{ display: 'flex' }}
						onChange={e => setDisabledValue(e.target.value)}
						value={disabled}
					>
						<div className={styles.radioColumn}>
							<Radio style={{ marginBottom: 16 }} value={false} defaultChecked={true}>Enabled</Radio>
							<Radio style={{ marginBottom: 16, marginLeft: 120 }} value={true}>Disabled</Radio>
						</div>
					</Radio.Group>
				</div>
				<div className={styles.section}>
					<Space>
						<h3 className={styles.label}>Sign Up Date Range</h3>
						<Input
							style={{ maxWidth: 170 }}
							title='From'
							type='date'
							value={fromDate ? moment(fromDate) : null }
							onChange={(date) => setFromDate(date?.toDate())}
						/>
						<Divider>
							<div className={styles.dash} />
						</Divider>
						<Input
							style={{ maxWidth: 170 }}
							title='To'
							type='date'
							value={toDate ? moment(toDate) : null }
							onChange={(date) => setToDate(date?.toDate())}
							disabledDate={current => current && current.valueOf() < moment(fromDate)}
						/>
					</Space>
				</div>
			</div>
		</Modal>
	)
}

export default DistributorFilterModal
